import axios from "@Core/axios";
import { BaseService } from "@Core/services";

import { AssignmentSnapshot, ChallengeSnapshot } from "@LNI/models";

class ChallengesService extends BaseService<ChallengeSnapshot> {
  getChallenges = async (): Promise<ChallengeSnapshot[] | null> => {
    const response = await axios.get(`${this.endpoint}`);

    if (response) {
      return response.data.map((challenge: ChallengeSnapshot) => ({
        ...challenge,
      }));
    }

    return null;
  };

  getAssignments = async (challenge: number): Promise<AssignmentSnapshot[] | null> => {
    const response = await axios.get(`challenges/${challenge}/assignments`);

    if (response) {
      const value = response.data.map((assignment: any) => {
        return {
          ...assignment,
          category: "CHALLENGE",
        };
      });

      return value;
    }

    return null;
  };

  setAnswer = async (challenge: number, assignment: number, question: number, answer: number): Promise<void> => {
    const data = {
      question: question,
      answer: answer,
    };

    await axios.post(`challenges/${challenge}/assignments/${assignment}`, data);
  };

  setCompleted = async (challenge: number, assignment: number): Promise<void> => {
    const data = {
      isDone: true,
    };

    await axios.post(`challenges/${challenge}/assignments/${assignment}`, data);
  };
}

export default new ChallengesService("challenges");
